import { Injector } from "@angular/core";
import { ResultList } from "../../ListEntity/ResultList";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { BaseNode } from "../../BaseNode";
import { QueryNodeInBox } from "../Query/QueryNodeInBox";
import { InBoxListView } from "../../../Data/WebTraderData/InBoxListView";
import { EntityEnum } from "../../EntityEnum";
import { PaginationControl } from "../../../PaginationControl";
import { WebTraderQueryResultNode } from "../WebTraderQueryResultNode";
import { DateUtil } from "../../../DateUtil";
import { QueryConditionNodeInbox } from "../Query/QueryConditionNodeInbox";
import { Art57NodeUtils } from "../../Art57Node/Art57NodeUtils";

export class ResultListNodeInbox extends ResultList {

    constructor (injector: Injector) {
        super(injector);
    }

    override addResult(requestedNode: BaseNode, itemPagination: PaginationControl, data: any, parentNode: BaseNode): BaseNode|null{
        const listViewData = new InBoxListView(data);
        let resultNodeInbox = null;
        const selectedNode = requestedNode; 
        if ( selectedNode instanceof QueryNodeInBox || selectedNode instanceof WebTraderQueryResultNode) {
            selectedNode.data = listViewData;
        } else {
            const conditionsNode = Art57NodeUtils.findChildNodeOfType(this.parent!.children as BaseNode[],QueryConditionNodeInbox) as QueryConditionNodeInbox;
            resultNodeInbox = new WebTraderQueryResultNode(this.ioc!,listViewData,"Result " + DateUtil.getResultDateTime(), EntityEnum.inb,null,conditionsNode, []);
            resultNodeInbox.paginationControl = itemPagination;
            if (data.length > 0) {
                if (!(this.ioc!.get(Art57Section).getSelectedSection().selectedNode instanceof QueryNodeInBox)) {
                    resultNodeInbox.parent = parentNode;
                    this.children?.push(resultNodeInbox);
                } else {
                    resultNodeInbox.parent = requestedNode;
                }
            } 
        }

        return resultNodeInbox;
    }
}
